module.exports = __webpack_public_path__ + "static/media/tp-min.691bb61e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/tp-min.svg
// module id = 696
// module chunks = 0